// extracted by mini-css-extract-plugin
export var form = "recipe-notes-module--form--7d3c9";
export var input = "recipe-notes-module--input--da19f";
export var note = "recipe-notes-module--note--f0e1f";
export var submitButton = "recipe-notes-module--submit-button--58ce0";